import Result from 'slotworks/model/gameplay/records/results/result';
import { BuyoutTypes } from 'components/bonus-buy/bonus-buy-prompt';

export default class BuyoutResult extends Result {
    public type: BuyoutTypes;
    public totalBetCash: number = 0;
}



// WEBPACK FOOTER //
// ./src/integration/buyout-result.ts